import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { CookieBannerComponent } from 'cookie-banner/cookie-banner.component';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'ce-cookie-dialog',
    templateUrl: './cookie-dialog.component.html',
    styleUrls: ['./cookie-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class CookieDialogComponent {
    currentStatus: string;

    // observable for user choice
    private readonly _userChoiceStatus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(undefined);
    userChoiceStatus$ = this._userChoiceStatus.asObservable();
    userChoiceStatus = false;

    // observable for radio button default value
    private readonly _defaultValue: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(undefined);
    defaultValue$ = this._userChoiceStatus.asObservable();
    defaultValue = false;

    static open(matDialog: MatDialog) {
        return matDialog.open(CookieDialogComponent);
    }

    stopClickPropagate(event) {
        event.stopPropagation();
    }

    constructor(
        private cookieBannerComponent: CookieBannerComponent,
        private cdRef: ChangeDetectorRef,
        private dialogRef: MatDialogRef<CookieDialogComponent>
    ) {}

    ngOnInit() {
        const currentChoice = this.cookieBannerComponent.readConsentChoice();
        this.updateDefaultValue(currentChoice);
    }

    updateDefaultValue(currentChoice: boolean) {
        this._defaultValue.next(currentChoice);
        this.defaultValue = currentChoice;
    }

    // update users cookie consent sttus
    updateUserChoiceStatus(newChoice: boolean) {
        this._userChoiceStatus.next(newChoice);
        this.userChoiceStatus = newChoice;
        this.cdRef.markForCheck();
    }

    // sets current user consent status according to 'CE usage analytics' browser cookies
    currentConsentStatus() {
        if (this.cookieBannerComponent.readConsentChoice()) {
            this.currentStatus = 'Accept analytics cookies';
        } else {
            this.currentStatus = 'Decline analytics cookies';
        }
        return this.currentStatus;
    }

    // save new user cookie consent choice
    save() {
        this.cookieBannerComponent.updateConsentChoice(this.userChoiceStatus);
        this.cdRef.markForCheck();
    }

    // close dialog
    cancel() {
        this.dialogRef.close();
    }
}
